import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import { grey } from '@material-ui/core/colors';
import { Typography } from '@material-ui/core';
import LogoAvatar from './LogoAvatar';
// components
import MessageBox from './MessageBox';
import MessageTextLink from './MessageTextLink';
import QuickResponse from './QuickResponse';
import MessageCard from './MessageCard';
// models
import Message, { MessageDirection, MessageStatus, MessageType } from '../models/Message';
import MessageCardCarousel from './MessageCardCarousel';

const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
        width: '100%',
    },

    box: {
        //margin: theme.spacing(1),
    },
    status: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    avatar: {
        color: "theme.palette.getContrastText(grey[200])",
        backgroundColor: "grey[200]",
        objectFit: "cover",
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    avatarArea: {
        color: "theme.palette.getContrastText(grey[200])",
        backgroundColor: "grey[50]",
        width: '40px',
        maxWidth: '40px',
        minWidth: '40px',
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(2),
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
    },
    statusText: {
        color: grey[500],
    }
  }));
  
const RenderReceivedMessage = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    //const dt = new Date();
    return (
        <div>
            <CssBaseline />
            {
                (()=>{
                    switch(message.messageType){
                        case MessageType.QUICK_RESPONSE: return (
                            <Box className={classes.box} display="flex" alignItems="flex-start" justifyContent="flex-start"  id="quickRespGrid">   {/**Added BY SKY */}
                                <Box className={classes.avatarArea} /> 
                                <QuickResponse itemIndex={props.itemIndex} message={message} actions={props.actions} />
                            </Box>
                        );
                        case MessageType.CARD: return (
                            <Box className={classes.box} display="flex" alignItems="flex-start" justifyContent="flex-start">
                                {/* <Box className={classes.avatarArea} /> COMMENTED OUT TO REMOVE EXTRA SPACE ON LEFT */}
                                <MessageCard itemIndex={props.itemIndex} message={message} actions={props.actions} />
                            </Box>
                        );
                        case MessageType.CARD_CAROUSEL: return (
                            <Box className={classes.box} display="flex" alignItems="flex-start" justifyContent="flex-start">
                                {/* <Box className={classes.avatarArea} /> COMMENTED OUT TO REMOVE EXTRA SPACE ON LEFT */}
                                <MessageCardCarousel itemIndex={props.itemIndex} message={message} actions={props.actions} />
                            </Box>
                        );
                        case MessageType.TEXT_LINK: return (
                            <Box className={classes.box} display="flex" alignItems="flex-end" justifyContent="flex-start"> 
                                <LogoAvatar />
                                <MessageTextLink itemIndex={props.itemIndex} message={message} actions={props.actions} />
                            </Box>
                        );
                        case MessageType.TEXT:default: return (
                            <Box className={classes.box} display="flex" alignItems="flex-end" justifyContent="flex-start">
                                <LogoAvatar />
                                <MessageBox itemIndex={props.itemIndex} message={message} actions={props.actions}/>
                                {/* 
                                    <Typography className={classes.statusText} variant="caption" display="block" gutterBottom>
                                    {
                                        (() => {
                                            const dt = new Date();
                                            return (dt.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
                                        })()
                                    }
                                    </Typography>
                                */}
                            </Box>
                        );
                    }
                })()
            }
                
                {/* 
                <Typography className={classes.statusText} variant="caption" display="block" gutterBottom>
                    {
                        (() => {
                            return (dt.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
                        })()
                    }
                </Typography> 
                */}
            
        </div>
    );
}

const RenderSentMessage = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message as Message;
    const dt = new Date();
    return (     
        <div className={classes.root}>
            <CssBaseline />
            <Box className={classes.box} display="flex" flexDirection="row-reverse" alignItems="flex-end" justifyContent="flex-start">             
                <MessageBox itemIndex={props.itemIndex} message={message} />
            </Box>
            <Box className={classes.status} display="flex" flexDirection="row-reverse" alignItems="flex-start" justifyContent="flex-start">
                <Typography className={classes.statusText} variant="caption" display="block" gutterBottom>
                    {
                        (() => {
                            switch(message.messageStatus) {
                                case MessageStatus.SENDING: return "sending...";
                                case MessageStatus.SENT: return (dt.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'}));
                                default: return '';
                            }
                        })()
                    }
                </Typography>
            </Box>
        </div>
    );
}
  
const ChatItem = (props:any) => {
    const classes = useStyles();
    const message:Message = props.message;
    if(props.message.messageDirection===MessageDirection.RECEIVED){
        return <RenderReceivedMessage itemIndex={props.itemIndex} message = {message} state={props.state} actions={props.actions} />
    }else if(props.message.messageDirection===MessageDirection.SENT){
        return <RenderSentMessage itemIndex={props.itemIndex} message = {message} />
    }else{
        return (     
            <div className={classes.root}>
                <CssBaseline />
                <Box className={classes.box} display="flex" flexDirection="row" alignItems="flex-end" justifyContent="flex-start">   
                    <Avatar>!</Avatar>             
                    <div>Something went wrong!</div>
                </Box>
            </div>
        );
    }    
};

export default ChatItem;